// Maintenance mode is ACTIVE. Every URL on kiwicharts.com renders the
// Maintenance page while a new engine is built. To restore the full site:
// revert the PR that introduced this change (search git log for
// "claude/maintenance-mode"). The Chart / Landing / NotFound imports below
// are intentionally kept commented (NOT deleted) so reverting is a
// 4-line edit — uncomment the imports + restore the Routes block.
//
// Worker API (`server.kiwicharts.com`) is intentionally NOT touched.

// import { Route, Routes } from "react-router-dom";
// import { Chart } from "./routes/Chart";
// import { Landing } from "./routes/Landing";
// import { NotFound } from "./routes/NotFound";

import { Maintenance } from "./routes/Maintenance";

export function App() {
    return <Maintenance />;
    // return (
    //     <Routes>
    //         <Route path="/" element={<Landing />} />
    //         <Route path="/chart" element={<Chart />} />
    //         <Route path="*" element={<NotFound />} />
    //     </Routes>
    // );
}
